import { render, staticRenderFns } from "./HistoryBroadcast.vue?vue&type=template&id=00f5f63e&"
import script from "./HistoryBroadcast.vue?vue&type=script&lang=js&"
export * from "./HistoryBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports